import type { Answer, AnswerRequest } from "../../../../dynamicForm";
import { AGREEMENTS_QUESTION_ID, getPartnerIds, SUPPLIER_QUESTION_ID } from "../../../../agreements/supplierQuestions";

export const withAgreementsOfRemovedSuppliersDropped = (
  answer: AnswerRequest,
  savedAnswers: Array<Answer>
): Array<AnswerRequest> => {
  if (answer.questionId !== SUPPLIER_QUESTION_ID || answer.type !== "multiplePartnerInput") {
    return [answer];
  }
  const agreementsAnswer = savedAnswers.find(saved => saved.questionId === AGREEMENTS_QUESTION_ID);
  if (agreementsAnswer?.type !== "multipleAgreementInput" || !agreementsAnswer.value) {
    return [answer];
  }
  const remainingPartnerIds = getPartnerIds(answer.value);
  const remainingAgreements = agreementsAnswer.value.filter(selected =>
    remainingPartnerIds.includes(selected.partnerId)
  );
  if (remainingAgreements.length === agreementsAnswer.value.length) {
    return [answer];
  }
  return [answer, { questionId: AGREEMENTS_QUESTION_ID, type: "multipleAgreementInput", value: remainingAgreements }];
};
